(function () {
  const header = () => {
    const body = document.querySelector("body");
    const header = document.querySelector(".shopify-section-header");
    const headerDetails = document.querySelector(".menu-drawer-container");
    const headerIsAlwaysSticky =
      header
        .querySelector(".header-wrapper")
        .getAttribute("data-sticky-type") === "always";
    const announcementHeight =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--announcement-height"
        )
      ) || 0;

    headerDetails.addEventListener("toggle", function (e) {
      const colorScheme =
        this.querySelector("#menu-drawer").dataset.colorScheme;
      header.classList.toggle(colorScheme);
    });

    document.addEventListener("keyup", (e) => {
      if (e.key === "Escape") {
        header.classList.remove("shopify-section-header-sticky", "animate");
        body.classList.remove("overflow-hidden");
      }
    });

    document.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
        header.classList.add("fixed", "animate");
      } else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
        header.classList.remove("fixed", "animate");
      }
      if (scrollTop > announcementHeight && headerIsAlwaysSticky) {
        if (header.classList.contains("header-overlay")) {
          header.style.position = "fixed";
          header.style.top = `0px`;
        }
      } else if (scrollTop <= announcementHeight && headerIsAlwaysSticky) {
        if (header.classList.contains("header-overlay")) {
          header.style.position = "absolute";
          header.style.top = `${announcementHeight}px`;
        }
      }
    });

    const addBackground = () => {
      if (header.classList.contains("color-inverse")) {
        header.classList.remove("color-inverse");
      }
    };

    const removeBackground = () => {
      if (document.body.classList.contains("overflow-hidden-tablet")) {
        return;
      }
      if (header.classList.contains("header-overlay")) {
        header.classList.add("color-inverse");
      }
    };

    header.addEventListener("mouseenter", addBackground);

    header.addEventListener("focus", addBackground);

    header.addEventListener("focusin", addBackground);

    header.addEventListener("mouseleave", removeBackground);

    header.addEventListener("focusout", removeBackground);
  };

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();
  // When child menu items extend beyond the container, need to change the childmenue opening direction.
  const headerSubMenu = () => {
    const dir = document.querySelector("html").getAttribute("dir");
    const listMenu = document.querySelector(".header__menu .list-menu");
    const listMenuRect = listMenu.getBoundingClientRect();

    const allSubmenus = listMenu.querySelectorAll(
      ".header__submenu .list-menu-has-child .header__submenu"
    );
    allSubmenus.forEach((item) => {
      const itemRect = item.getBoundingClientRect();
      if (dir === "ltr") {
        if (itemRect.right > listMenuRect.right) {
          item.style.left = "auto";
          item.style.right = "100%";
        }
      } else {
        if (itemRect.left < listMenuRect.left) {
          item.style.left = "100%";
          item.style.right = "auto";
        }
      }
    });
  };

  headerSubMenu();

  const calculateMenuTabsPosition = () => {
    const dir = document.querySelector("html").getAttribute("dir");
    const listMenu = document.querySelector(".header__menu .list-menu");
    const allMenuTabLinks = listMenu.querySelectorAll(
      ".header__menu-item.header__menu-tab-link"
    );
    const wrapperPaddings = 64;

    allMenuTabLinks.forEach((item) => {
      const megaMenuTabs = item.nextElementSibling;

      if (megaMenuTabs && megaMenuTabs.classList.contains("mega-submenu")) {
        const menuWrapperElem = megaMenuTabs.querySelector(
          ".header-mega-menu__wrapper"
        );
        const submenuListElem = megaMenuTabs.querySelector(
          ".header-mega-menu__have-submenu__list"
        );
        const submenuListElems = megaMenuTabs.querySelectorAll(
          ".header-mega-menu__have-submenu__list > li"
        );
        const menuTabsSubmenuElems = megaMenuTabs.querySelectorAll(
          ".mega-submenu__submenu"
        );

        if (menuWrapperElem && submenuListElem && menuTabsSubmenuElems.length) {
          const submenuListElemRectWidth =
            submenuListElem.getBoundingClientRect().width;
          const menuWrapperElemRect = menuWrapperElem.getBoundingClientRect();
          let submenuWidth = 0;
          let submenuHeight = 0;
          menuTabsSubmenuElems.forEach((subElem) => {
            const subElemtRect = subElem.getBoundingClientRect();
            const subElemWidth = subElemtRect.width;
            const subElemHeight = subElemtRect.height + wrapperPaddings / 2;
            if (subElemWidth > submenuWidth) {
              submenuWidth = subElemWidth;
            }

            if (subElemHeight > submenuHeight) {
              submenuHeight = subElemHeight;
            }

            if (dir === "rtl") {
              subElem.style.right = `${
                submenuListElemRectWidth + wrapperPaddings
              }px`;
            } else {
              subElem.style.left = `${
                submenuListElemRectWidth + wrapperPaddings
              }px`;
            }
          });

          // wrapper tabs
          menuWrapperElem.style.width = `${
            submenuListElemRectWidth + submenuWidth + wrapperPaddings
          }px`;
          let menuWrapperElemHeight =
            menuWrapperElemRect.height + wrapperPaddings / 2;
          if (menuWrapperElemRect.height < submenuHeight) {
            menuWrapperElemHeight = submenuHeight;
          }
          menuWrapperElem.style.height = `${menuWrapperElemHeight}px`;

          // tabs container
          if (dir === "rtl") {
            if (
              menuWrapperElem.getBoundingClientRect().left - wrapperPaddings <
              0
            ) {
              megaMenuTabs.style.left = "2rem";
            }
          } else {
            if (
              menuWrapperElem.getBoundingClientRect().right + wrapperPaddings >
              window.innerWidth
            ) {
              megaMenuTabs.style.right = "2rem";
            }
          }
        }

        // details part
        submenuListElems.forEach((subItem) => {
          subItem.addEventListener("mouseenter", function (event) {
            const current = event.target;
            let parentEl = null;

            if (current.classList.contains("header-mega-menu__submenu-link")) {
              parentEl = current.closest(".header-mega-menu-list-item");
            }

            const submenuListElem = current.closest(
              ".header-mega-menu__have-submenu__list"
            );
            const listElements =
              submenuListElem?.querySelectorAll(":scope > li");

            if (!listElements.length) return;

            listElements.forEach((el) => {
              const detailsEl = el.querySelector("details");
              if (el === parentEl) {
                detailsEl?.setAttribute("open", "true");
                return;
              }

              if (el === current) {
                detailsEl?.setAttribute("open", "true");
                return;
              }

              const menuSublink = el.querySelector(".header-menu-sublink");
              menuSublink?.classList.remove("active");
              detailsEl?.removeAttribute("open");
            });
          });
        });
      }
    });
  };

  calculateMenuTabsPosition();
})();
